/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

export default function HomeFooterSection() {
  return (
    <footer className="bg-white border-t border-primary/5 pt-20 pb-10 px-6 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-12 mb-20">
          <div className="col-span-2">
            <div className="flex items-center gap-2.5 mb-6">
              <div className="bg-primary p-1.5 rounded-xl shadow-md">
                <span
                  className="material-symbols-outlined text-white text-xl"
                  style={{ fontVariationSettings: '"FILL" 1' }}
                >
                  directions_run
                </span>
              </div>
              <h2 className="text-xl font-black tracking-tighter">Errandi</h2>
            </div>
            <p className="text-slate-500 max-w-xs leading-relaxed text-sm">
              Your personal runner service. Fast errands, trusted people, and
              seamless delivery at your fingertips.
            </p>
            <div className="flex gap-4 mt-6">
              <a
                className="text-slate-400 hover:text-primary transition-colors hover:scale-110 inline-block"
                href="#"
              >
                <span className="material-symbols-outlined">
                  alternate_email
                </span>
              </a>
              <a
                className="text-slate-400 hover:text-primary transition-colors hover:scale-110 inline-block"
                href="#"
              >
                <span className="material-symbols-outlined">share</span>
              </a>
              <a
                className="text-slate-400 hover:text-primary transition-colors hover:scale-110 inline-block"
                href="#"
              >
                <span className="material-symbols-outlined">
                  social_leaderboard
                </span>
              </a>
            </div>
          </div>
          <div>
            <h4 className="font-black mb-6 text-[10px] uppercase tracking-widest text-primary">
              Service
            </h4>
            <ul className="space-y-3.5 text-sm font-semibold text-slate-500">
              <li>
                <a className="hover:text-primary transition-colors" href="#">
                  How it Works
                </a>
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="#">
                  Pricing
                </a>
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="#">
                  Track Errand
                </a>
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="#">
                  Business Plan
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-black mb-6 text-[10px] uppercase tracking-widest text-primary">
              Trust
            </h4>
            <ul className="space-y-3.5 text-sm font-semibold text-slate-500">
              <li>
                <a className="hover:text-primary transition-colors" href="#">
                  Verification
                </a>
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="#">
                  Safety Policy
                </a>
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="#">
                  Insurance
                </a>
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="#">
                  Terms
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-black mb-6 text-[10px] uppercase tracking-widest text-primary">
              Runners
            </h4>
            <ul className="space-y-3.5 text-sm font-semibold text-slate-500">
              <li>
                <a className="hover:text-primary transition-colors" href="#">
                  Apply Now
                </a>
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="#">
                  Requirements
                </a>
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="#">
                  Runner Hub
                </a>
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="#">
                  Runner App
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-black mb-6 text-[10px] uppercase tracking-widest text-primary">
              Company
            </h4>
            <ul className="space-y-3.5 text-sm font-semibold text-slate-500">
              <li>
                <a className="hover:text-primary transition-colors" href="#">
                  About Us
                </a>
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="#">
                  Contact
                </a>
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="#">
                  Blog
                </a>
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="#">
                  Careers
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col md:flex-row items-center justify-between pt-10 border-t border-primary/6 gap-6">
          <div className="flex gap-5">
            <a
              className="text-slate-400 hover:text-primary transition-colors"
              href="#"
            >
              <span className="material-symbols-outlined">
                social_leaderboard
              </span>
            </a>
            <a
              className="text-slate-400 hover:text-primary transition-colors"
              href="#"
            >
              <span className="material-symbols-outlined">share</span>
            </a>
            <a
              className="text-slate-400 hover:text-primary transition-colors"
              href="#"
            >
              <span className="material-symbols-outlined">alternate_email</span>
            </a>
          </div>
          <p className="text-slate-400 text-sm font-medium">
            © 2026 Errandi Technologies Ltd. All rights reserved.
          </p>
          <div className="flex gap-3 text-xs font-semibold text-slate-400">
            <a href="#" className="hover:text-primary transition-colors">
              Privacy
            </a>
            <span>·</span>
            <a href="#" className="hover:text-primary transition-colors">
              Terms
            </a>
            <span>·</span>
            <a href="#" className="hover:text-primary transition-colors">
              Cookies
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
